import { Route } from 'react-router-dom';
import Guidance from 'pages/guidance'
import MVGuidance from 'modules/intensiveCare/components/Guidance/MVGuidance';
import Calculators from 'pages/calculators/calculators';
import IdealWeight from 'modules/intensiveCare/components/idealWeight';
import SDRA from 'modules/intensiveCare/components/SDRA';
import Drugs from 'pages/drugs';
import * as drugsData from 'config/data';
import Drug from 'pages/drug';
import DrugType from 'modules/intensiveCare/models/DrugType';

const MechanicalVentilation = [
  <Route
    exact
    path="/mechanical-ventilation/guidance"
    key="/mechanical-ventilation/guidance"
    render={() => <Guidance title="Ventilação mecânica"><MVGuidance /></Guidance>}
  />,
  <Route 
    exact 
    path="/mechanical-ventilation/calculators" 
    key="/mechanical-ventilation/calculators" 
    component={Calculators} 
  />,
  <Route 
    exact 
    path="/mechanical-ventilation/calculators/ideal-weight" 
    key="/mechanical-ventilation/calculators/ideal-weight" 
    component={IdealWeight}
  />,
  <Route 
    exact 
    path="/mechanical-ventilation/calculators/sdra" 
    key="/mechanical-ventilation/calculators/sdra" 
    component={SDRA} 
  />,
  <Route
    exact
    path="/mechanical-ventilation/drugs/"
    key="/mechanical-ventilation/drugs/"
    render={({ match }) => <Drugs
      title="Ventilação mecânica"
      subtitle="Drogas"
      drugs={drugsData.maintenance}
      path={match.path}
    />}
  />,
  <Route 
    exact 
    path="/mechanical-ventilation/drugs/:drugKey"
    key="/mechanical-ventilation/drugs/:drugKey"
    render={props => <Drug drugType={DrugType.MAINTENANCE} drugId={props.match.params.drugKey} />}
  />,
];

export default MechanicalVentilation;
